export default __webpack_public_path__ + "static/media/mission.f9ddd324.jpg";